import React from "react";

// "see FAQ" is a link to a new page

const CCAlaCartRoyaltyFree = () => {
    return (
        <div>
            No attribution required. For license info, see{" "}
            <a
                href="https://help.thenounproject.com/hc/en-us/articles/200509798-What-licenses-do-you-use-"
                target="_blank"
            >
                FAQ
            </a>
            .
        </div>
    );
};

export default CCAlaCartRoyaltyFree;
